import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import Wraper from "../Components/Dashboard/Wraper/Wraper";
import Dashboard from "../layout/Admin/Dashboard/DashbaordMain";
import Profile from "../layout/Admin/Profile/Profile";
import ClientList from "../layout/Admin/Clients/ClientList/ClientList";
import AddClient from "../layout/Admin/Clients/ClientList/Add_Client";
import EditClient from "../layout/Admin/Clients/ClientList/Edit_Client";
import SignUpClients from "../layout/Admin/Clients/Sign_Up_Clients/Sign_Up_Clients";
import EditSignupClient from "../layout/Admin/Clients/Sign_Up_Clients/EditSignupClients";
import SignupClientDetails from "../layout/Admin/SignupClients/SignupClient_Details";
import ExpiredClients from "../layout/Admin/Clients/ExpiredClients/ExpiredClients";
import AllSubadmin from "../layout/Admin/SubAdmin/Subadmins/AllSubadmin";
import EditSubadmin from "../layout/Admin/SubAdmin/Subadmins/EditSubadmin";
import SubadminClient from "../layout/Admin/SubAdmin/Subadmin_Clients/Subadmin_Client";
import EditSubadminClient from "../layout/Admin/SubAdmin/Subadmin_Clients/EditSubadminClients";
import AddSubadmin from "../layout/Admin/SubAdmin/Subadmins/AddSubadmin";
import Signals from "../layout/Admin/TradeDetails/Signals/Signals";
import TradingStatus from "../layout/Admin/TradeDetails/TradingStatus/TradingStatus";
import Closeposition from "../layout/Admin/TradeDetails/TradeHistory/closeposition.jsx";
import Openposition from "../layout/Admin/TradeDetails/TradeHistory/openposition.jsx";
import AllLicence from "../layout/Admin/Licence/AllLicence/AllLicence";
import ExpiredLicence from "../layout/Admin/Licence/ExpiredLicence/ExpiredLicence";
import HelpCenter from "../layout/Admin/Support/HelpCenter/HelpCenter";
import MsgBroadCast from "../layout/Admin/Support/MsgBroadCast/MsgBroadCast";
import Service from "../layout/Admin/Service/AllService/AllService";
import GroupService from "../layout/Admin/Service/GroupService/GroupService";

import AddGroup from "../layout/Admin/Service/GroupService/Add_Group";
import EditGroup from "../layout/Admin/Service/GroupService/Edit_Group";
import Report from "../layout/Admin/Report/Report";
import ApiCreateInfo from "../layout/Admin/ApiCreateInfo/ApiCreateInfo";
import AddApiCreateInfo from "../layout/Admin/ApiCreateInfo/AddApiCreateInfo";
import EditApiCreateInfo from "../layout/Admin/ApiCreateInfo/EditApiCreateInfo";
import ReleaseUpdate from "../layout/Admin/ReleaseUpdate/ReleaseUpdate";
import System from "../layout/Admin/System/System";
import AllStrategy from "../layout/Admin/Service/AllStrategy/AllStrategy";
import AddStraegyNormal from "../layout/Admin/Service/AllStrategy/AddStraegyNormal";
import EditStrategyNormal from "../layout/Admin/Service/AllStrategy/EditStrategyNormal.jsx";
import BrokerInfor from "../layout/Admin/BrokersInformation/Broker_info";
import Faq from "../layout/Admin/Faq/Faq.jsx";
import Settings from "../layout/Admin/Profile/Settings";
import Landing_page_setting from "../layout/Admin/Profile/Landing_page_setting.jsx";
import Orders from "../layout/Admin/TradeDetails/Signals/Orders";
import CoinDCXGuide from "../layout/Admin/ApiCreateInfo/CoinDCXGuide";
import Pi42 from "../layout/Admin/ApiCreateInfo/Pi42.jsx";

import Deltaexchange from "../layout/Admin/ApiCreateInfo/Deltaexchange";
import Trade from "../layout/Admin/Trade/trade.jsx";
import Binance from "../layout/Admin/ApiCreateInfo/Binance.jsx";
import Orders1 from "../layout/Admin/TradeDetails/Ordes.jsx";
import CoinSwitch from "../layout/Admin/ApiCreateInfo/CoinSwitch.jsx";
import Tradehistory from "../layout/Admin/TradeDetails/TradeHistory/tradehistory.jsx";
import TradeMonitoring from "../layout/Admin/Trade_Monitoring/Broker_Trade_Monitoring.jsx";
import TradeCalculation from "../layout/Admin/TradeCalculation/TradeCalculation.jsx";

import Optionchain from "../layout/Admin/Optionchain/Optionchain.jsx";
import CoinDCXDashboardView from "../layout/Admin/CoinDCX/CoinDCX.jsx";
import CoinSwitchDashboardView from "../layout/Admin/CoinSwitch/CoinSwitch.jsx";
import ReportBug from "../layout/Common/ReportBug";







const Admin = () => {
  const location = useLocation();
  const roles = JSON.parse(localStorage.getItem("user_role"));
  const token = JSON.parse(localStorage.getItem("user_details")).token;
  const [admin_permission, setAdmin_permission] = useState([]);

  const permission = JSON.parse(localStorage.getItem("permission"));

  return (
    <>
      {location.pathname !== "/admin" && location.pathname !== "/admin/*" ? (
        <Wraper />
      ) : null}
      <Routes>
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/system" element={<System />} />
        <Route exact path="/allclients" element={<ClientList />} />
        <Route exact path="/expiredclients" element={<ExpiredClients />} />
        {permission?.Addclient == 1 && <Route exact path="/client/add" element={<AddClient />} />}
        <Route exact path="/client/edit/:id" element={<EditClient />} />
        <Route exact path="/signupclients" element={<SignUpClients />} />
        <Route exact path="/editsignupclients" element={<EditSignupClient />} />
        <Route exact path="/allsubadmins" element={<AllSubadmin />} />
        <Route exact path="/editsubadmin/:id" element={<EditSubadmin />} />
        <Route exact path="/subadminclients" element={<SubadminClient />} />
        <Route exact path="/allsubadmins/add" element={<AddSubadmin />} />
        <Route
          exact
          path="/allsubadmins/edit"
          element={<EditSubadminClient />}
        />
        <Route exact path="/strategies" element={<AllStrategy />} />
        {permission && permission?.Create_Strategy == 1 && (
          <Route exact path="/strategies/add" element={<AddStraegyNormal />} />
        )}
        <Route
          exact
          path="/strategies/edit/:id"
          element={<EditStrategyNormal />}
        />
        <Route exact path="/signupclient" element={<SignupClientDetails />} />

        <Route exact path="/tradingstatus" element={<TradingStatus />} />
        <Route exact path="/openposition" element={<Openposition />} />
        <Route exact path="/closeposition" element={<Closeposition />} />

        <Route exact path="/signals" element={<Signals />} />
        <Route exact path="/allLicence" element={<AllLicence />} />
        <Route exact path="/expiredlicence" element={<ExpiredLicence />} />
        <Route exact path="/helpcenter" element={<HelpCenter />} />
        <Route exact path="/msgbroadcast" element={<MsgBroadCast />} />
        <Route exact path="/allservices" element={<Service />} />
        <Route exact path="/groupservices" element={<GroupService />} />
        <Route exact path="/groupservices/add" element={<AddGroup />} />
        <Route exact path="/groupservices/edit/:id" element={<EditGroup />} />
        <Route exact path="/reports" element={<Report />} />
        <Route exact path="/apicreateinfo" element={<ApiCreateInfo />} />

        <Route exact path="/apicreateinfo/add" element={<AddApiCreateInfo />} />
        <Route
          exact
          path="/apicreateinfo/edit"
          element={<EditApiCreateInfo />}
        />
        <Route
          exact
          path="/apicreateinfo/coinDCXGuide"
          element={<CoinDCXGuide />}
        />
        <Route
          exact
          path="/apicreateinfo/pifourtwo"
          element={<Pi42 />}
        />
        <Route
          exact
          path="/apicreateinfo/Deltaexchange"
          element={<Deltaexchange />}
        />
        <Route exact path="/apicreateinfo/binance" element={<Binance />} />
        <Route exact path="/apicreateinfo/CoinSwitchGuide" element={<CoinSwitch />} />

        <Route exact path="/updates" element={<ReleaseUpdate />} />
        <Route exact path="/brokerinfo" element={<BrokerInfor />} />
        <Route exact path="/faq" element={<Faq />} />
        <Route exact path="/settings" element={<Settings />} />
        <Route exact path="/landing_page_setting" element={<Landing_page_setting />} />



        <Route exact path="/Orders" element={<Orders />} />
        <Route exact path="/trade" element={<Trade />} />
        <Route exact path="/order" element={<Orders1 />} />
        <Route exact path="/tradehistory" element={<Tradehistory />} />

        <Route exact path="/trademonitoring" element={<TradeMonitoring />} />

        <Route exact path="/tradecalculation" element={<TradeCalculation />} />

        <Route exact path="/optionchain" element={<Optionchain />} />
        <Route exact path="/coindcx-terminal" element={<CoinDCXDashboardView />} />
        <Route exact path="/coinswitch-terminal" element={<CoinSwitchDashboardView />} />
        <Route exact path="/bug" element={<ReportBug />} />


        {/* Catch-all route for any unmatched paths */}
      </Routes>
    </>
  );
};

export default Admin;
